import {
    SET_BASE_ALERT,
    SET_BASE_ALERT_SOCKET,
    SET_CURRENT_ALERT,
    SET_CURRENT_ALERT_SOCKET,
    SHOW_HIDE_ALERTS,
    HIDE_ALERTS,
    SHOW_ALERTS_BY_CURRENT_COMPANY
} from "../action/alert";


const stateModal = {
    baseAlerts: [],
    currentAlerts: [],
    companyIds: "all",
    active: false
}

function alerts(state = stateModal, action) {
    switch (action && action.type) {
        case SET_BASE_ALERT:{
            let alerts = action.data.reduce((acc, item) => {
                if(item.aqiFrom !== undefined && item.aqiFrom <= 5 && item.aqiTo !== undefined && item.aqiTo <= 5) {
                    item.show = true;
                    acc.push(item);
                }
                return acc;
            }, [])
            state.baseAlerts = alerts.reverse();
            return {...state}
        }
        case SHOW_HIDE_ALERTS:
            state.active = !state.active;
            return {...state}
        case SHOW_ALERTS_BY_CURRENT_COMPANY:
            const companyIds = action.data;
            state.companyIds = companyIds;
            if(Array.isArray(companyIds)) {
                state.baseAlerts = state.baseAlerts.reduce((acc, item) => {
                   if(companyIds[0] === "all") {
                     item.show = true;
                     acc.push(item);
                     return acc;
                   }
                   if(companyIds.indexOf(item.deviceId) !== -1){
                       item.show = true;
                       acc.push(item);
                       return acc;
                   } else {
                       item.show = false;
                       acc.push(item);
                       return acc;
                   }
                }, []);
            }
            return {...state}
        case HIDE_ALERTS:
            state.active = false;
            return {...state}
        case SET_BASE_ALERT_SOCKET:
            if(state.companyIds[0] !== "all" && state.companyIds.indexOf(action.data.deviceId)!==-1) {
                state.baseAlerts = [{...action.data},...state.baseAlerts];
            }
            if(state.companyIds[0] === "all") {
                state.baseAlerts = [{...action.data},...state.baseAlerts];
            }
            return {...state}
        case SET_CURRENT_ALERT: {
            let baseAlerts = state.baseAlerts;
            const actionId = action.data.id.indexOf("__d") !== -1 ? action.data.id.replace("__d", "") : action.data.id;
            let currentAlerts = baseAlerts.reduce((acc, item) => {
                if(item.deviceId === actionId) {
                    acc.push(item);
                }
                return acc;
            }, [])
            state.currentAlerts = currentAlerts;
            return {...state}
        }
        case SET_CURRENT_ALERT_SOCKET:
            state.currentAlerts = [{...action.data},...state.currentAlerts ];
            return {...state}
        default:
            return state;
    }
}

export default alerts;

